import { FIELD_BASE_TYPES, getBaseTypeById } from "./BaseTypes";
import { DynamicField } from "./DynamicField";
import { FIELD_TYPES, getFieldTypeById } from "./FieldTypes";
import { FormulairePayload } from "./FormulairePayload";

export interface Formulaire {
  titre: string;
  fields: DynamicField[];
}

export function transformFormulairePayload(payload: FormulairePayload): Formulaire {
  const fields: DynamicField[] = [];

  payload.sectionContenus.forEach((sc) => {
    const section = sc.section;

    sc.contenus.forEach((contenu) => {
      const dbType = getBaseTypeById(contenu.typeBase) ?? FIELD_BASE_TYPES.TEXT;
      const type = getFieldTypeById(contenu.typeChamp) ?? FIELD_TYPES.TEXT;

      const fieldId = "field_" + (contenu.idContenu ?? crypto.randomUUID());

      const dynamicField: DynamicField = {
        id: fieldId,
        label: contenu.nomContenu,
        section: section
          ? {
              id: section.idSection?.toString() ?? "0",
              name: section.nomSection,
            }
          : undefined,
        type,
        dbType,
        options:
          ["select", "radio", "checkbox"].includes(type.value)
            ? contenu.valueSelect?.split(",") ?? []
            : undefined,
        optionsValues:
          ["select", "radio", "checkbox"].includes(type.value)
            ? contenu.valueSelect?.split(",") ?? []
            : undefined,
            
        conditionalLogic: contenu.conditionalLogic
          ? {
              fieldId,
              operator: contenu.conditionalLogic.operator,
              value: contenu.conditionalLogic.value,
              parentFieldId: contenu.conditionalLogic.parentFieldId,              
              parentContenuId: contenu.conditionalLogic.parentContenuId,
              parentFieldIndex: contenu.conditionalLogic.parentFieldIndex,
            }
          : undefined,
      };

      fields.push(dynamicField);
    });
  });

  return {
    titre: payload.titre,
    fields,
  };
}